import { AsyncComponent } from '@frontend/elements';
import { lazy } from 'react';
import { Route } from 'react-router-dom';

const LabelTemplateOverview = lazy(() => import('./label-template-overview/label-template-overview'));
const LabelTemplateDetail = lazy(() => import('./label-template-detail/label-template-detail.component'));
const LabelTemplateCreate = lazy(() => import('./label-template-create/label-template-create.component'));
const LabelTemplateUpdate = lazy(() => import('./label-template-update/label-template-update.component'));

const LabelTemplateContentCreate = lazy(() => import('../label-content/label-content-create/label-content-create.component'));
const LabelTemplateContentDetail = lazy(() => import('../label-content/label-content-detail/label-content-detail.component'));

//TODO
// const LabelTemplateCopy = lazy(() => import('./label-template-copy/label-template-copy.component'));

export function LabelTemplateRoutes() {
    return (
        <Route path='label-templates'>
            <Route
                index
                element={
                    <AsyncComponent>
                        <LabelTemplateOverview />
                    </AsyncComponent>
                }
            />
            <Route
                path='create'
                element={
                    <AsyncComponent>
                        <LabelTemplateCreate />
                    </AsyncComponent>
                }
            />
            <Route path=':templateId'>
                <Route
                    index
                    path='detail'
                    element={
                        <AsyncComponent>
                            <LabelTemplateDetail />
                        </AsyncComponent>
                    }
                />
                <Route
                    path='update'
                    element={
                        <AsyncComponent>
                            <LabelTemplateUpdate />
                        </AsyncComponent>
                    }
                />
                {/* <Route
                    path='copy'
                    element={
                        <AsyncComponent>
                            <LabelTemplateCopy />
                        </AsyncComponent>
                    }
                /> */}
                <Route path='content'>
                    <Route
                        path='create'
                        element={
                            <AsyncComponent>
                                <LabelTemplateContentCreate />
                            </AsyncComponent>
                        }
                    />
                    <Route path=':contentId'>
                        <Route
                            index
                            path='detail'
                            element={
                                <AsyncComponent>
                                    <LabelTemplateContentDetail />
                                </AsyncComponent>
                            }
                        />
                    </Route>
                </Route>
            </Route>
        </Route>
    );
}

export default LabelTemplateRoutes;
